import 'dayjs/locale/en'; // English
import 'dayjs/locale/pt'; // Portuguese
import 'dayjs/locale/es'; // Spanish

export default {
  methods: {
    setDayjsLocale(locale) {
        if (['en', 'pt', 'es'].includes(locale)) {
            this.$dayjs.locale(locale);
        } else {
            this.$dayjs.locale('es');
        }
    }
  },
  created() {
    if (this.$page?.props?.current_locale) {
      this.setDayjsLocale(this.$page.props.current_locale);
    }
  }
};